import type {
  BulkImportRowClassification,
  BulkImportSessionStatus,
} from '@/services/bulk-import.service';

export const CLASSIFICATION_LABELS: Record<BulkImportRowClassification, string> = {
  PASS_EXISTING: 'Pass — Existing Match',
  PASS_NEW: 'Pass — New Equipment',
  WARNING: 'Warning',
  FAIL: 'Fail',
  CONFLICT: 'Conflict',
};

export const CLASSIFICATION_BADGE: Record<BulkImportRowClassification, string> = {
  PASS_EXISTING: 'bg-green-500/10 text-green-700',
  PASS_NEW: 'bg-teal-500/10 text-teal-700',
  WARNING: 'bg-amber-500/10 text-amber-700',
  FAIL: 'bg-red-500/10 text-red-700',
  CONFLICT: 'bg-purple-500/10 text-purple-700',
};

export const SESSION_STATUS_LABELS: Record<BulkImportSessionStatus, string> = {
  UPLOADED: 'Awaiting Upload',
  VALIDATING: 'Processing',
  REVIEW_REQUIRED: 'Review Required',
  COMMITTING: 'Committing',
  PARTIALLY_COMPLETED: 'Partially Completed',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
};

export const SESSION_STATUS_BADGE: Record<BulkImportSessionStatus, string> = {
  UPLOADED: 'bg-blue-500/10 text-blue-600',
  VALIDATING: 'bg-amber-500/10 text-amber-700',
  REVIEW_REQUIRED: 'bg-purple-500/10 text-purple-700',
  COMMITTING: 'bg-amber-500/10 text-amber-700',
  PARTIALLY_COMPLETED: 'bg-orange-500/10 text-orange-700',
  COMPLETED: 'bg-green-500/10 text-green-700',
  FAILED: 'bg-red-500/10 text-red-700',
  CANCELLED: 'bg-muted text-muted-foreground',
  EXPIRED: 'bg-muted text-muted-foreground',
};

export type WorkspaceStage = 'setup' | 'upload' | 'processing' | 'review' | 'final';

export function stageForStatus(status: BulkImportSessionStatus): WorkspaceStage {
  switch (status) {
    case 'UPLOADED':
      return 'upload';
    case 'VALIDATING':
    case 'COMMITTING':
      // COMMITTING reuses the same bounded-polling "processing" stage as
      // VALIDATING (Phase 2f-F) — the chunked commit write runs in a
      // background worker exactly like validation does; the UI has no
      // synchronous result to show until the session leaves this status.
      return 'processing';
    case 'REVIEW_REQUIRED':
    case 'PARTIALLY_COMPLETED':
      return 'review';
    default:
      // COMPLETED/FAILED/CANCELLED/EXPIRED — genuine terminal states.
      return 'final';
  }
}
